export default {
  pt: {
    'mapa.locationMap.notConfigured': 'Mapa não configurado',
    'mapa.locationMap.missingToken': 'Token público do Mapbox ausente no runtime-config.',
    'mapa.locationMap.unavailable': 'Mapa indisponível',
    'mapa.locationMap.loadFailed': 'Não foi possível carregar o mapa neste dispositivo.',
    'mapa.locationMap.polygonHint': 'Use o botão de polígono e clique no mapa para desenhar a cerca. Feche no primeiro ponto.',
    'mapa.locationMap.noCoordinates': 'Sem coordenadas',
    'mapa.locationMap.clickToMark': 'Clique no mapa para marcar a posição.',
    'mapa.locationMap.enterCoordinates': 'Informe latitude e longitude para posicionar no mapa.',
  },
  en: {
    'mapa.locationMap.notConfigured': 'Map not configured',
    'mapa.locationMap.missingToken': 'Public Mapbox token is missing from runtime-config.',
    'mapa.locationMap.unavailable': 'Map unavailable',
    'mapa.locationMap.loadFailed': 'The map could not be loaded on this device.',
    'mapa.locationMap.polygonHint': 'Use the polygon button and click the map to draw the geofence. Close it at the first point.',
    'mapa.locationMap.noCoordinates': 'No coordinates',
    'mapa.locationMap.clickToMark': 'Click the map to mark the position.',
    'mapa.locationMap.enterCoordinates': 'Enter latitude and longitude to position it on the map.',
  },
  es: {
    'mapa.locationMap.notConfigured': 'Mapa no configurado',
    'mapa.locationMap.missingToken': 'Falta el token público de Mapbox en runtime-config.',
    'mapa.locationMap.unavailable': 'Mapa no disponible',
    'mapa.locationMap.loadFailed': 'No se pudo cargar el mapa en este dispositivo.',
    'mapa.locationMap.polygonHint': 'Use el botón de polígono y haga clic en el mapa para dibujar la geocerca. Ciérrela en el primer punto.',
    'mapa.locationMap.noCoordinates': 'Sin coordenadas',
    'mapa.locationMap.clickToMark': 'Haga clic en el mapa para marcar la posición.',
    'mapa.locationMap.enterCoordinates': 'Introduzca la latitud y la longitud para ubicarlo en el mapa.',
  },
}
